import {
  REQUEST_MANAGER_PENDING_CLAIMS,
  SET_MANAGER_PENDING_CLAIMS,
} from 'containers/ManagerPendingClaims/constants';

export const requestManagerPendingClaims = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_MANAGER_PENDING_CLAIMS,
  status,
  page,
  pageSize,
});

export const setManagerPendingClaims = (isManagerSearching: boolean) => (
  response: any,
) => ({
  type: SET_MANAGER_PENDING_CLAIMS,
  response,
  isManagerSearching,
});
